<template>
  <!-- HTML 정의하는 부분 -->
  <!-- 1차 퍼블리셔가 작업 영역 -->
  <!-- 2차 개발자가 Template 화 작업 진행-->
  <div>
    <v-card elevation="0" width="450px" height="150px">
      <v-card-title @click="pageRedirect">
        <img :src="chargeImage" alt>
        <span>&nbsp;&nbsp;</span>
        <v-tooltip bottom>
          <template v-slot:activator="{on,attrs}">
            <div class="overflow-hidden"
                 style="width: 290px; text-overflow: ellipsis;white-space: nowrap;" v-bind="attrs" v-on="on">{{infoData.DESCRIPTION}}</div>
          </template>
          <span>{{infoData.DESCRIPTION}}</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col class="pt-0" md="9">
            <v-row>
              <v-col
                class="py-0 text-body-2"
                md="3"
                style=" padding-left: 5px; padding-right: 5px;"
              >주소</v-col>
              <v-col class="py-0 text-body-2" style="padding-left: 2px;">{{infoData.LOCATION}}</v-col>
            </v-row>
            <v-row class="pa-0">
              <v-col
                class="text-body-2"
                md="3"
                style=" padding-left: 5px; padding-right: 5px;"
              >설치일자</v-col>
              <v-col class="text-body-2" style="padding-left: 2px;">{{installDate}}</v-col>
            </v-row>
          </v-col>
          <v-col class="pt-0 pl-1" md="3">
            <v-spacer></v-spacer>
            <v-btn
              small
              id="cctvBtn"
              @click="goCctv"
              v-show="cctvView"
              color="#0784F2"
              class="mb-3"
              width="80"
            >
              <v-icon>mdi-cctv</v-icon>CCTV
            </v-btn>
            <v-btn small id="infoBtn" color="#0784F2" @click="pageRedirect" width="80">상세보기</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-if="viewPopup" v-model="viewPopup" persistent max-width="600px">
      <cctv-popup @closeDetailPop="viewPopup=false" :cctv-cnt="infoData.CCTV_CNT" :site-id="infoData.SITE_ID"></cctv-popup>
    </v-dialog>
  </div>
</template>

<script>
// 스크립트를 정의하는 부분
// 개발자 작업 영역
// [ECMA6] export default 된 부분이 외부에서 import로 사용할 수 있게 된다.
import day from 'dayjs'
import { isTablet } from '@/utils/check'
import CctvPopup from '@/views/pc/site/CctvPopup'
export default {
  // .vue 내부에서 사용되는 model
  // model 기반으로 vue는 동작된다.
  name: 'SiteInfoWindowPop',
  components: {
    CctvPopup
  },
  props: {
    infoData: {
      type: Object,
      default: () => {
        return {
          siteId: 'M2189',
          title: '테스트 홍성 지정리 지정3호태양광',
          location: '테스트 충청남도 홍성군 구항면 지정리 129',
          date: day('2020-11-13T15:00:00.000+0000').format('YYYY년 MM월 DD일'),
          charge: '유료',
          cctvView: false
        }
      }
    }
  },
  data() {
    return {
      viewPopup: false,
      charge: require('@/assets/image/monitoring/mark-charge.png'),
      free: require('@/assets/image/monitoring/mark-free.png')
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    installDate() {
      return day(this.infoData.CRT_DATE).format('YYYY년 MM월 DD일')
    },
    chargeImage() {
      if (this.infoData.TYPE === '유료') {
        return this.charge
      } else {
        return this.free
      }
    },
    cctvView() {
      return this.infoData.CCTV_STAT !== null && this.infoData.CCTV_STAT !== 'N'
    }
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    goCctv() {
      if (isTablet()) {
        this.$router.push('/cctvPopup?siteId=' + this.infoData.SITE_ID + '&cctvCnt=' + this.infoData.CCTV_CNT)
      } else {
        this.viewPopup = true

        // let routeData = this.$router.resolve({
        //   name: 'cctvPopup',
        //   query: {
        //     cctvInfo: JSON.stringify({
        //       cctv_cnt: this.infoData.CCTV_CNT,
        //       site_id: this.infoData.SITE_ID
        //     })
        //   }
        // })

        // window.open(
        //   routeData.href,
        //   '',
        //   'width=' +
        //     window.outerWidth / 1.5 +
        //     ', height=' +
        //     window.outerHeight / 1.3 +
        //     ''
        // )
      }
    },
    pageRedirect() {
      // console.log('클릭!!!')
      if (this.infoData.SITE_ID.indexOf('E') > -1) {
        this.$router.push('/ess/siteWork?site_id=' + this.infoData.SITE_ID)
      } else {
        this.$router.push('/siteWork?site_id=' + this.infoData.SITE_ID)
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* css 혹은 less로 스타일 정의하는 부분 */
/* 퍼블리셔 작업 영역 */

// lang="less"로 <style> 태그에 속성으로 넣어야 less를 사용할 수 있다.

.test-box {
  border: 1px solid lightgreen;
}
.ft {
  font-family: Noto Sans KR !important;
  font-size: 13px !important;
}
</style>
